import flexiDomainsLogo from '../assets/images/flexi_domains_logo.svg';
import flexiEmailLogo from '../assets/images/flexi_email_logo.svg';
import flexiBotLogo from '../assets/images/flexi_bot_logo.svg';
import flexiBillingLogo from '../assets/images/flexi_billing_logo.svg';
import flexiMarketplaceLogo from '../assets/images/flexi_marketplace_logo.svg';
import flexiStripeLogo from '../assets/images/flexi_stripe_logo.svg';
import flexiAdminLogo from '../assets/images/flexi_admin_logo.svg';

const logoMap: Record<string, string> = {
    'flexi domains': flexiDomainsLogo,
    'flexi email': flexiEmailLogo,
    'flexi bot': flexiBotLogo,
    'billing console': flexiBillingLogo,
    'marketplace console': flexiMarketplaceLogo,
    'stripe console': flexiStripeLogo,
    'admin console': flexiAdminLogo,
};

export const getApplicationLogo = (appName?: string): string | undefined => {
    if (!appName) return undefined;
    return logoMap[appName.toLowerCase().trim()];
};
